/**
 * Рабочие пространства.
 *
 * Пространство описывает вид, а не права: спрятанный пункт меню не закрывает
 * доступ, и наоборот. Клиент строит меню по этому описанию, ничего не решая сам.
 */

import { request } from "@/shared/api/client";

export type WorkspaceKind = "internal" | "portal";

export interface MenuItem {
  key: string;
  label?: string;
  icon?: string;
  to?: string;
  children?: MenuItem[];
}

export interface Workspace {
  id: number;
  code: string;
  name: string;
  description: string | null;
  kind: WorkspaceKind;
  menu: MenuItem[];
  settings: Record<string, unknown>;
  view_ids: number[];
  report_ids: number[];
  is_default: boolean;
  is_active: boolean;
  position: number;
  principals: number[];
  created_at: string;
  updated_at: string;
}

export interface WorkspaceDraft {
  code: string;
  name: string;
  description?: string | null;
  kind?: WorkspaceKind;
  menu?: MenuItem[];
  settings?: Record<string, unknown>;
  view_ids?: number[];
  report_ids?: number[];
  principals?: number[];
  position?: number;
}

export interface Section {
  key: string;
  title: string;
}

export function myWorkspaces(): Promise<Workspace[]> {
  return request<Workspace[]>("/api/workspaces/mine");
}

export function listWorkspaces(): Promise<Workspace[]> {
  return request<Workspace[]>("/api/workspaces");
}

export function sections(): Promise<Section[]> {
  return request<Section[]>("/api/workspaces/sections");
}

export function createWorkspace(draft: WorkspaceDraft): Promise<Workspace> {
  return request<Workspace>("/api/workspaces", { method: "POST", body: draft });
}

export function updateWorkspace(
  workspaceId: number,
  patch: Partial<WorkspaceDraft> & { is_active?: boolean },
): Promise<Workspace> {
  return request<Workspace>(`/api/workspaces/${String(workspaceId)}`, {
    method: "PATCH",
    body: patch,
  });
}

export function deleteWorkspace(workspaceId: number): Promise<undefined> {
  return request<undefined>(`/api/workspaces/${String(workspaceId)}`, { method: "DELETE" });
}

const STORAGE_KEY = "plantask.workspace";

/** Выбранное пространство переживает перезагрузку: это рабочее место, а не фильтр. */
export function rememberedWorkspace(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function rememberWorkspace(code: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Приватное окно или запрет на хранение: пространство просто не запомнится
  }
}
